import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the change password view.
 */
export default class changePasswordView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section for new password input
        const center_left = {
            margin: 5,
            rows: [
                {
                    view: 'text',
                    name: 'NewPassword', // Input field for new password
                    type: 'password',
                    label: _('Nueva Contraseña'), // Label for new password
                    labelPosition: 'top',
                    placeholder: _('Nueva Contraseña'), // Placeholder text
                    required: true, // Field is required
                    invalidMessage: 'Campo Requerido', // Error message for validation
                },
            ],
        };

        // Right section (currently empty)
        const center_right = {
            margin: 5,
            rows: [],
        };

        // Right section for confirm password input
        const right = {
            margin: 5,
            rows: [
                {
                    view: 'text',
                    name: 'ConfirmPassword', // Input field for confirming password
                    type: 'password',
                    label: _('Confirmar Contraseña'), // Label for confirm password
                    labelPosition: 'top',
                    placeholder: _('Confirmar Contraseña'), // Placeholder text
                    required: true, // Field is required
                    invalidMessage: 'Campo Requerido', // Error message for validation
                },
            ],
        };

        // Upper section layout combining left and right sections
        const upper_section = {
            cols: [
                center_left,
                { gravity: 0, minWidth: 10 }, // Spacer
                right,
            ],
        };

        // Button section with actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button',
                    value: _('Guardar'), // Save button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        if (this.getRoot().validate()) {
                            // Validate form
                            const newPassword = this.getRoot().getValues(); // Get form values
                            const cur_user = this.getParam('league', true); // Get current user parameter
                            if (
                                newPassword.NewPassword === newPassword.ConfirmPassword // Check if passwords match
                            ) {
                                console.log('Nueva Contraseña', newPassword); // Log new password
                                console.log('usuario', cur_user); // Log current user
                                const data = {
                                    LeagueId: cur_user, // Prepare data for API call
                                    NewPassword: newPassword.NewPassword,
                                    ConfirmPassword: newPassword.ConfirmPassword,
                                };
                                webix
                                    .ajax()
                                    .headers({
                                        'Content-type': 'application/json', // Set content type
                                    })
                                    .post(
                                        devConfig.geturlApi() + // API endpoint
                                            'Leagues/ChangePassword',
                                        data,
                                        {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message(_('Error')); // Show error message
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var json = JSON.parse(text); // Parse response
                                                webix.message(_('Guardado')); // Show success message
                                            },
                                        },
                                    );
                                this.getRoot().clear(); // Clear form after submission
                            } else {
                                webix.message({
                                    title: _('¡Error!'), // Error title
                                    type: 'alert-error',
                                    text: _('Contraseñas no coinciden'), // Error message for password mismatch
                                });
                            }
                        } else {
                            webix.message({
                                title: _('¡Error!'), // Error title
                                type: 'alert-error',
                                text: _('Completa los campos...'), // Error message for incomplete fields
                            });
                        }
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            id: 'formChangePassword', // Form ID
            rows: [upper_section, buttons], // Combine upper section and buttons
            elementsConfig: {
                on: {
                    onChange: function (newv, oldv) {
                        this.validate(); // Validate on change
                    },
                },
            },
        };
    }
}

// FILE DOCUMENTED
